import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { ButtonInLink } from '@hivebrite/design-system/ButtonInLink';

import useCustomTopicName from 'hb-react/shared/apps/TopicsIndexV2/hooks/useCustomTopicName';
import useTopicsMenuName from 'hb-react/shared/apps/TopicsIndexV2/hooks/useTopicsMenuName';
import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';
import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

const SuccessMessageJoinPublicTopic = ({
  displaySuccessMessage,
  setDisplaySuccessMessage,
}) => {
  const { isDisplayed, name, href, forceDefaultLink, target } =
    displaySuccessMessage;

  dayjs.locale(window.__HB_LOCALE__);

  const topicName = useCustomTopicName();
  const tabName = useTopicsMenuName();

  return isDisplayed ? (
    <ModalWithTemplate
      onCloseModal={setDisplaySuccessMessage}
      screenReadersCloseButtonText={s__(
        'TopicsAccessibility|Close request to join a public topic',
      )}
      header={s__('Topics|You have joined a new %{topicName}!').i__({
        topicName,
      })}
      width="440px"
      dataTestId="successful-join-public-topic-modal"
      footer={
        <Box>
          <Button variant="secondary" onClick={setDisplaySuccessMessage} mr={4}>
            {s__('Topics|Discover more %{tabName}').i__({
              tabName,
            })}
          </Button>
          <ButtonInLink
            linkProps={{
              to: href,
              forceDefaultLink,
              target,
              onClick: setDisplaySuccessMessage,
            }}
          >
            {s__('Topics|Go To %{topicName}').i__({
              topicName,
            })}
          </ButtonInLink>
        </Box>
      }
    >
      <Box width="100%" flexDirection="column">
        <Box>
          {s__('Topics|Thank you for joining %{name}').i__({
            name,
          })}
        </Box>
        <Box>
          {I18n.t('web.topics.member_requests.requested_at', {
            date: dayjs().format('lll'),
          })}
        </Box>
      </Box>
    </ModalWithTemplate>
  ) : null;
};

SuccessMessageJoinPublicTopic.protoTypes = {
  displaySuccessMessage: PropTypes.bool.isRequired,
  setDisplaySuccessMessage: PropTypes.func.isRequired,
};

export default SuccessMessageJoinPublicTopic;
